export default {
  email: 'Email',
  password: 'Password',
  enter: 'Sign in',
  emailIsRequired: 'EEmail cannot be empty',
  emailIsInvalid: 'Email is not valid',
  passwordIsRequired: 'Password cannot be empty',
  notFound: 'User not found',
  Unauthorized: 'Invalid password',
  genericErrorMsg: 'Oops, we couldn\'t log in, please try again later.',
};
